import React, { useState, useEffect } from "react";
import { Button, Form, Row, Col } from "react-bootstrap";
import { Employee } from "../types/Employee";
import { YearMonthDateFormatDate } from "../config/functions";
import { apiUrl } from "../config";
import { Eye, EyeOff } from "react-feather";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";
import { getRoles } from "../services/RolesService";
import { AppDispatch } from "../redux/store";
import { RoleActionType } from "../redux/actions/roleAction";

interface Props {
  employeeIdToEdit?: number;
  onSave: (employee: Employee) => void;
  initialData?: Employee | null;
  readOnly?: boolean;
}
const initialState: Employee = {
  id: 0,
  employeeId: "",
  password: "",
  otp: 0,
  otp_exp_time: "",
  role: "",
  name: "",
  gender: "",
  birhDate: "",
  mobileNumber: "",
  emailId: "",
  aadharNumber: "",
  address1: "",
  address2: "",
  address3: "",
  location: "",
  district: "",
  state: "",
  postalCode: "",
  qualification: "",
  experience: "",
  designation: "",
  department: "",
  panNumber: "",
  joinDate: "",
  releaveDate: null,
  status: "Active",
  photoUrl: null,
};

const EmployeeForm: React.FC<Props> = ({
  employeeIdToEdit,
  onSave,
  initialData,
  readOnly = false,
}) => {
  const [employee, setEmployee] = useState<Employee>(
    initialData || initialState,
  );
  const dispatch = useDispatch<AppDispatch>();
  const [photoPreview, setPhotoPreview] = useState<string | null>(null);
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const rolePer = useSelector((state: StoreState) => state.role);
  console.log("ROLE ONLY", rolePer);

  useEffect(() => {
    const fetchRoles = async () => {
      const data = await getRoles();
      console.log("da", data);

      dispatch({
        type: RoleActionType.FETCH_ROLES,
        data: data,
      });
    };

    fetchRoles();
  }, []);
  useEffect(() => {
    if (employeeIdToEdit) {
      loadEmployee(employeeIdToEdit);
    }
  }, [employeeIdToEdit]);

  const loadEmployee = async (id: number) => {
    // const res = await getEmployeeById(id);
    // setEmployee(res.data);
  };

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = e.target;
    setEmployee((prev: Employee) => ({
      ...prev,
      [name]: value,
    }));
  };

  const [isEditable, setIsEditable] = useState<boolean>(!readOnly);

  useEffect(() => {
    if (!initialData && !readOnly) {
      setEmployee(initialState);
    } else if (initialData) {
      setEmployee(initialData);
    }
    setIsEditable(!readOnly);
  }, [initialData, readOnly]);
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onSave(employee);
  };

  const handleClear = () => {
    setEmployee(initialState);
    setPhotoPreview(null);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const input = e.target as HTMLInputElement;
    const file = input.files?.[0] || null;

    if (file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        setPhotoPreview(e.target?.result as string);
      };

      reader.readAsDataURL(file);

      setEmployee((prev) => ({ ...prev, photoUrl: file }));
    } else {
      setPhotoPreview(null);
      setEmployee((prev) => ({ ...prev, photoUrl: null }));
    }
  };

  useEffect(() => {
    return () => {
      if (photoPreview && photoPreview.startsWith("blob")) {
        URL.revokeObjectURL(photoPreview);
      }
    };
  }, [photoPreview]);

  useEffect(() => {
    if (initialData) {
      setEmployee(initialData);
      if (initialData.photoUrl) {
        if (typeof initialData.photoUrl === "string") {
          // Existing image URL
          setPhotoPreview(apiUrl + "/" + initialData.photoUrl);
        } else if (initialData.photoUrl instanceof File) {
          // New file selected
          const url = URL.createObjectURL(initialData.photoUrl);
          setPhotoPreview(url);
        }
      } else {
        setPhotoPreview(null);
      }
    } else {
      setEmployee(initialState);
      setPhotoPreview(null);
    }
  }, [initialData]);

  return (
    <>
      <Form onSubmit={handleSubmit}>
        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="employeeId">
              <Form.Label>
                Employee ID <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="employeeId"
                value={employee.employeeId}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          {employee.id === 0 && (
            <Col className="form-column">
              <Form.Group controlId="password">
                <Form.Label>
                  Password <span className="text-danger">*</span>
                </Form.Label>
                <div style={{ position: "relative" }}>
                  <Form.Control
                    type={showPassword ? "text" : "password"}
                    name="password"
                    value={employee.password}
                    onChange={handleChange}
                    disabled={!isEditable}
                    // required={employee.id === 0}
                    required
                  />
                  <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                      position: "absolute",
                      top: "10%",
                      right: "10px",
                      cursor: "pointer",
                      transform: "translate(-50%)",
                    }}
                  >
                    {showPassword ? <Eye /> : <EyeOff />}
                  </span>
                </div>
                <Form.Text className="text-muted">
                  {employee.id === 0
                    ? "Enter a password for new employee"
                    : "Leave blank to keep existing password"}
                </Form.Text>
              </Form.Group>
            </Col>
          )}

          <Col className="form-column">
            <Form.Group controlId="role">
              <Form.Label>
                Role <span className="text-danger">*</span>
              </Form.Label>
              {/* <Form.Select
                name="role"
                value={employee.role || ""}
                onChange={handleChange}
                disabled={!isEditable}
                style={{
                  borderColor: "rgb(215, 210, 210)",
                }}
                required
              >
                <option value="">Select</option>
                <option value="Admin">Admin</option>
                <option value="User">User</option>
              </Form.Select> */}
              <Form.Select
                name="role"
                value={employee.role || ""}
                onChange={handleChange}
                disabled={!isEditable}
                required
              >
                <option value="">Select</option>

                {rolePer.map((role: any) => (
                  <option key={role.id} value={role.roleName}>
                    {role.roleName}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="name">
              <Form.Label>
                Full Name <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={employee.name}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="gender">
              <Form.Label>
                Gender <span className="text-danger">*</span>
              </Form.Label>
              <br />
              <Form.Select
                name="gender"
                value={employee.gender}
                onChange={handleChange}
                disabled={readOnly}
                required
                style={{
                  borderColor: "rgb(215, 210, 210)",
                }}
              >
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </Form.Select>
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="birhDate">
              <Form.Label>
                Birth Date <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="birhDate"
                value={YearMonthDateFormatDate(employee.birhDate)}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="emailId">
              <Form.Label>
                Email <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="email"
                name="emailId"
                value={employee.emailId}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="mobileNumber">
              <Form.Label>
                Mobile Number <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="mobileNumber"
                value={employee.mobileNumber}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="aadharNumber">
              <Form.Label>
                Aadhar Number <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="aadharNumber"
                value={employee.aadharNumber}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="panNumber">
              <Form.Label>
                panNumber <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="panNumber"
                value={employee.panNumber || ""}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="designation">
              <Form.Label>
                designation <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="designation"
                value={employee.designation}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="department">
              <Form.Label>
                department <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="department"
                value={employee.department || ""}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="qualification">
              <Form.Label>
                Qualification <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="qualification"
                value={employee.qualification}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="experience">
              <Form.Label>
                Experience <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="experience"
                value={employee.experience}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="joinDate">
              <Form.Label>
                Join Date <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="date"
                name="joinDate"
                value={employee.joinDate}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="address1">
              <Form.Label>
                Address Line 1 <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="address1"
                value={employee.address1}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="address2">
              <Form.Label>Address Line 2</Form.Label>
              <Form.Control
                type="text"
                name="address2"
                value={employee.address2}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="address3">
              <Form.Label>Address Line 3</Form.Label>
              <Form.Control
                type="text"
                name="address3"
                value={employee.address3}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="location">
              <Form.Label>
                Location <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={employee.location}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="district">
              <Form.Label>
                District <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="district"
                value={employee.district}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="state">
              <Form.Label>
                State <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="state"
                value={employee.state}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="postalCode">
              <Form.Label>
                Postal Code <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                type="text"
                name="postalCode"
                value={employee.postalCode}
                onChange={handleChange}
                disabled={!isEditable}
                required
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="releaveDate">
              <Form.Label>Releave Date</Form.Label>
              <Form.Control
                type="date"
                name="releaveDate"
                value={employee.releaveDate || ""}
                onChange={handleChange}
                disabled={!isEditable}
              />
            </Form.Group>
          </Col>
          <Col className="form-column">
            <Form.Group controlId="status">
              <Form.Label>Status</Form.Label>
              <br />
              <Form.Select
                name="status"
                value={employee.status}
                onChange={handleChange}
                disabled={!isEditable}
                style={{
                  borderColor: "rgb(215, 210, 210)",
                }}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </Form.Select>
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-1">
          <Col className="form-column">
            <Form.Group controlId="photoUrl">
              <Form.Label>Photo</Form.Label>
              <br />
              <input
                type="file"
                accept="image/*"
                onChange={handleFileChange}
                disabled={!isEditable}
              />
              {photoPreview && (
                <div className="mt-2">
                  <img
                    src={photoPreview}
                    alt="Preview"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "cover",
                      marginTop: "10px",
                    }}
                  />
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Row className="mb-1">
          <Col md={12}>
            {!readOnly && (
              <div className="form-buttons">
                <Button type="submit" className="btn-save">
                  {initialData?.id ? "Update" : "Save"}
                </Button>
                <Button
                  type="button"
                  className="btn-clear"
                  onClick={handleClear}
                >
                  Clear All
                </Button>
              </div>
            )}
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default EmployeeForm;
